(() => {
  const root = document.querySelector('[data-proof-v3]');
  if (!root) return;

  const legacyOpening = root.closest('main')?.querySelector(':scope > .pk-destination-opening');
  if (legacyOpening) legacyOpening.hidden = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const progress = root.querySelector('[data-proof-progress]');
  const hero = root.querySelector('[data-proof-hero]');
  const reveals = [...root.querySelectorAll('[data-proof-reveal]')];

  root.classList.add('is-enhanced');

  if (!reducedMotion.matches && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((element) => revealObserver.observe(element));
  } else {
    reveals.forEach((element) => element.classList.add('is-visible'));
  }

  let ticking = false;
  const updateScrollEffects = () => {
    const rootTop = root.getBoundingClientRect().top + window.scrollY;
    const available = Math.max(root.offsetHeight - window.innerHeight, 1);
    const percentage = Math.min(Math.max((window.scrollY - rootTop) / available, 0), 1);
    if (progress) progress.style.transform = `scaleX(${percentage})`;

    if (hero && !reducedMotion.matches) {
      const heroRect = hero.getBoundingClientRect();
      const shift = Math.max(-28, Math.min(28, heroRect.top * -0.045));
      hero.style.setProperty('--pk-proof-hero-shift', `${shift}px`);
    }
    ticking = false;
  };

  const requestScrollUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateScrollEffects);
  };

  root.querySelectorAll('[data-proof-accordion]').forEach((group) => {
    group.querySelectorAll('details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        const action = detail.querySelector('summary em');
        if (action) {
          const isBoundary = detail.closest('.pk-proof-v3__boundary-list');
          const isQuestion = detail.closest('.pk-proof-v3__question-list');
          action.textContent = detail.open
            ? (isBoundary ? 'Close limit' : isQuestion ? 'Close answer' : 'Close record')
            : (isBoundary ? 'Read limit' : isQuestion ? 'View answer' : 'View record');
        }
        if (!detail.open) return;
        group.querySelectorAll('details[open]').forEach((openDetail) => {
          if (openDetail !== detail) openDetail.removeAttribute('open');
        });
      });
    });
  });

  window.addEventListener('scroll', requestScrollUpdate, { passive: true });
  window.addEventListener('resize', requestScrollUpdate, { passive: true });
  updateScrollEffects();
})();
